// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceId } from './Device';
import { operatorId } from './Operator';
import { z } from 'zod';
export const deviceCommandAuditId = (z.string());
export const deviceCommandAudit = z.object({
    id: deviceCommandAuditId,
    device_id: deviceId,
    kind: z.string(),
    target: z.string(),
    value: z.string().nullable(),
    payload: z.unknown().nullable(),
    status: z.string().nullable(),
    error: z.string().nullable(),
    issued_by: operatorId.nullable(),
    issued_at: z.date(),
    acked_at: z.date().nullable(),
});
export const deviceCommandAuditInitializer = z.object({
    id: deviceCommandAuditId.optional(),
    device_id: deviceId,
    kind: z.string(),
    target: z.string(),
    value: z.string().optional().nullable(),
    payload: z.unknown().optional().nullable(),
    status: z.string().optional().nullable(),
    error: z.string().optional().nullable(),
    issued_by: operatorId.optional().nullable(),
    issued_at: z.date().optional(),
    acked_at: z.date().optional().nullable(),
});
export const deviceCommandAuditMutator = z.object({
    id: deviceCommandAuditId.optional(),
    device_id: deviceId.optional(),
    kind: z.string().optional(),
    target: z.string().optional(),
    value: z.string().optional().nullable(),
    payload: z.unknown().optional().nullable(),
    status: z.string().optional().nullable(),
    error: z.string().optional().nullable(),
    issued_by: operatorId.optional().nullable(),
    issued_at: z.date().optional(),
    acked_at: z.date().optional().nullable(),
});
//# sourceMappingURL=DeviceCommandAudit.js.map